import { FeatureBarComponent } from 'components/main/feature-bar/feature-bar.component'
export default FeatureBarComponent
